import {Injectable} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {Logger} from '~local/app/core/services/LoggerService';

const log = new Logger('IconService');

@Injectable()
export class IconService {

    // custom icons (.svg only) from assets folder
    // if icon css doesn't work check if svg contains fill
    private customIcons = {
        icon_support: 'local:assets/images/icon_support.svg',
        btc: 'local:assets/currency-icons/BTC-alt.svg',
        dash: 'local:assets/currency-icons/DASH-alt.svg',
        gbp: 'local:assets/currency-icons/gbp.svg',
        pound: 'local:assets/currency-icons/gbp.svg',
        usd: 'local:assets/currency-icons/DOLLAR-alt.svg',
        dollar: 'local:assets/currency-icons/DOLLAR-alt.svg',
        eth: 'local:assets/currency-icons/ETH-alt.svg',
        eur_trust: 'local:assets/currency-icons/EUR_TRUST-alt.svg',
        usd_trust: 'local:assets/currency-icons/USD_TRUST-alt.svg',
        eur: 'local:assets/currency-icons/EUR-alt.svg',
        euro: 'local:assets/currency-icons/EUR-alt.svg',
        ltc: 'local:assets/currency-icons/LTC-alt.svg',
        mof: 'local:assets/currency-icons/MOF-alt.svg',
        usdc: 'local:assets/currency-icons/USDC-alt.svg',
        usdt: 'local:assets/currency-icons/USDT-alt.svg',
    }

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {}

    loadCustomIcons(){
        for (const key in this.customIcons) {
            if (this.customIcons.hasOwnProperty(key)) {
                let path = this.customIcons[key];
                this.matIconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(path));

            } else {
                log.debug(`Icon ${key} doesn't exist`);
            }
        }
    }

}
